import ScrollHandler from './scroll/scrollHandler';
import Progressbar from './scroll/progressbar';

ScrollHandler.init();
Progressbar.init();
